import { fetcher } from "helpers/fetcher";

import { TGetStaffStatusDetailReq, TGetStaffStatusDetailRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffStatusDetail = async (
  payload: TGetStaffStatusDetailReq
) => {
  return await fetcher<
    TGetStaffStatusDetailRes,
    undefined,
    TGetStaffStatusDetailReq["params"]
  >(ENDPOINT.CORPORATION.GET_STAFF_STATUS_DETAIL, {
    urlData: { idStaffStatus: payload.params.idStaffStatus },
    headers: {
      [API_HEADER.USER_ID]: payload.userId,
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.GET_STAFF_STATUS_DETAIL.version,
    },
  });
};

export const queryGetStaffStatusDetail = async (
  payload: TGetStaffStatusDetailReq
) => {
  return (await getStaffStatusDetail(payload)).data;
};

queryGetStaffStatusDetail._key = (payload: TGetStaffStatusDetailReq) => [
  ENDPOINT.CORPORATION.GET_STAFF_STATUS_DETAIL.url,
  payload,
];
